import React from 'react';
import { DisabledTag } from '@nile/components';
import { Link } from '@superops/ui-design-system';
import { Tooltip } from 'react-clone-tippy';
import { SVGIcon } from '@superops/super-icons';
import { ASSETS_LIST_NUM } from '@nile/rmm/src/constants';
import { useFlags } from 'launchdarkly-react-client-sdk';

function PatchNameCell(props: { cell: any; intl: any }) {
  const flags = useFlags();
  const { cell } = props;
  const cellOriginal = cell?.row?.original;
  let val = '';
  try {
    val = cellOriginal?.patchDetail
      ? cellOriginal.patchDetail?.kbNumbers?.[0]?.kbNumber
      : cellOriginal?.kbNumbers?.[0]?.kbNumber;
  } catch (err) {
    console.log(err);
  }

  const title = cellOriginal?.patchDetail
    ? cellOriginal.patchDetail.title
    : cellOriginal?.title;
  const source = cellOriginal?.patchDetail || cellOriginal || {};
  const { summary, sentiment, knownIssues, stability } = source;
  const isAiPatchAvailable = !!(
    summary?.data ||
    sentiment?.data ||
    knownIssues?.description ||
    stability?.data
  );
  const classId =
    cell?.row?.original?.assetClass?.classId ||
    cell?.row?.original?.patchDetail?.assetClass?.classId;

  const microsoftURL = `https://support.microsoft.com/en-us/help/${val}`;
  const handleLinkClick = () => {
    if (classId === '3') {
      return;
    }
    if (
      cell?.column?.actions?.handlePatchSummaryModal &&
      flags?.patchClassicView
    ) {
      cell?.column?.actions?.handlePatchSummaryModal({
        patchId: cellOriginal?.patchId || cellOriginal?.patchDetail?.patchId,
        kbNumber: cellOriginal?.patchDetail
          ? cellOriginal.patchDetail.kbNumbers[0]?.kbNumber
          : cellOriginal?.kbNumbers[0]?.kbNumber
      });
    } else {
      window.open(
        microsoftURL,
        '_blank' // <- This is what makes it open in a new window.
      );
    }
  };

  const getTitle = (val: string, title: string) => {
    // Determine tooltip title conditionall
    const tooltipTitle = title || '';

    // If classId is not available, render a simpler version
    if (
      !cellOriginal?.patchDetail?.hasOwnProperty('summary') &&
      !cellOriginal?.hasOwnProperty('summary')
    ) {
      return (
        <Link
          onClick={val ? handleLinkClick : undefined}
          external
          fontWeight="bold"
        >
          <div
            className={`fx g10 items-center ${
              classId == '3' ? 'font-black' : 'linkText'
            }`}
          >
            {ASSETS_LIST_NUM[classId] ? (
              <div>
                <SVGIcon name={ASSETS_LIST_NUM[classId]} />
              </div>
            ) : null}

            <Tooltip className="ellipsis" title={tooltipTitle}>
              {title}
            </Tooltip>
          </div>
        </Link>
      );
    }

    // With classId, render the full version with icon
    return (
      <>
        <div className="fx g11">
          <div className="fx fx-sb items-center min-w50">
            {isAiPatchAvailable ? (
              <SVGIcon name="AIWand" size="md" />
            ) : (
              <div></div>
            )}
            <SVGIcon name={ASSETS_LIST_NUM[classId]} />
          </div>
          <Link
            onClick={val ? handleLinkClick : undefined}
            external
            fontWeight="bold"
          >
            <Tooltip title={tooltipTitle}>
              <div
                className={
                  classId === '3' || classId === '2'
                    ? 'font-black lh-20'
                    : 'lh-20'
                }
              >
                {title}
              </div>
            </Tooltip>
          </Link>
        </div>
      </>
    );
  };

  return title ? getTitle(val, title) : <DisabledTag>NA</DisabledTag>;
}

export default PatchNameCell;
